import { differenceInDays } from '@shared/utils/date';

const getNights = (searchQuery) => {
  const { departureDate, returnDate } = searchQuery;
  return differenceInDays(new Date(returnDate), new Date(departureDate));
};

export default getNights;
